<template>
  <TsButton
    :data-testid="deliveryCTATestid"
    :label="useTranslation('delivery', 'Bezorgen')"
    @click="emit('deliver')"
  />
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";

type Props = {
  productSlug?: string;
  isSticky?: boolean;
};

const props = withDefaults(defineProps<Props>(), {});

const deliveryCTATestid = computed(
  () =>
    `pdp-${props.productSlug}-delivery-btn` + (props.isSticky ? "-sticky" : "")
);

const emit = defineEmits(["deliver"]);
</script>
